






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-fire',

})
export default class IZoom extends Vue {

  @Prop({type: [String], default: 'white'}) protected color!: string

}

